/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkStatusCheckService } from 'utils/lib/network-status-check/network-status-check.service';

@Injectable({
    providedIn: 'root'
})
export class NetworkStatusService {
    constructor(private networkStatusCheckService: NetworkStatusCheckService) {}

    /**
     * Subscribe to receive notifications when online status has changed.
     */
    get onlineStatusChanged(): Observable<boolean> {
        return this.networkStatusCheckService.onlineStatusChanged();
    }

    /**
     * Get the current online status
     */
    get isOnline(): boolean {
        return this.networkStatusCheckService.isOnline();
    }
}
